var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmergencyCallout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.979,
    height: 37.535,
    viewBox: "0 0 25.979 37.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25671",
    "data-name": "Path 25671",
    d: "M.149,0H25.83a2.935,2.935,0,0,1,.149,1.294V36.241a2.935,2.935,0,0,1-.149,1.294H.149A2.934,2.934,0,0,1,0,36.241V1.294A2.934,2.934,0,0,1,.149,0Z",
    transform: "translate(0 0)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5,
    opacity: 0.53
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_16555",
    "data-name": "Mask Group 16555",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 5.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "light_siren_emergency_police_danger_urgency_signal_alarm_alert",
    "data-name": "light, siren, emergency, police, danger, urgency, signal, alarm, alert",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25661",
    "data-name": "Path 25661",
    d: "M150.737,107.3a.326.326,0,0,0,.108-.018c.126-.043.256-.081.385-.113a.337.337,0,1,0-.163-.655c-.148.037-.3.08-.44.126a.337.337,0,0,0,.11.66Z",
    transform: "translate(-139.095 -98.505)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25662",
    "data-name": "Path 25662",
    d: "M108.819,120.359a5.513,5.513,0,0,0-1.738,2.565.337.337,0,0,0,.218.424.33.33,0,0,0,.1.016.337.337,0,0,0,.321-.234,4.842,4.842,0,0,1,1.526-2.252.337.337,0,1,0-.43-.52Z",
    transform: "translate(-99.026 -111.25)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25663",
    "data-name": "Path 25663",
    d: "M51.308,98.673V97.548a1.786,1.786,0,0,0-1.784-1.784h-.2v-.807a1.767,1.767,0,0,0-1.762-1.765h-13.4V86.255a6.393,6.393,0,0,1,12.786,0v5.6a.337.337,0,0,0,.675,0v-5.6a7.068,7.068,0,0,0-14.136,0v6.94a1.765,1.765,0,0,0-1.7,1.762v.807h-.2A1.786,1.786,0,0,0,29.8,97.548v1.125a.338.338,0,0,0,.337.338h20.83a.338.338,0,0,0,.336-.338ZM32.459,94.957a1.091,1.091,0,0,1,1.091-1.091H47.563a1.091,1.091,0,0,1,1.09,1.091v.807H32.459Zm18.175,3.379H30.479v-.788a1.111,1.111,0,0,1,1.109-1.109H49.524a1.111,1.111,0,0,1,1.109,1.109Z",
    transform: "translate(-27.566 -73.242)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25664",
    "data-name": "Path 25664",
    d: "M143.514,200.794a.337.337,0,0,0,.337.337h4.4a.337.337,0,1,0,0-.675h-1.007v-1.766a1.51,1.51,0,0,0-3.021,0v1.766h-.366a.337.337,0,0,0-.34.337Zm1.378-2.1a.836.836,0,0,1,1.671,0v1.766h-1.671Z",
    transform: "translate(-132.739 -182.375)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25665",
    "data-name": "Path 25665",
    d: "M222.368,240.814a.337.337,0,1,0,0,.675h.1a.337.337,0,1,0,0-.675Z",
    transform: "translate(-205.36 -222.733)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25666",
    "data-name": "Path 25666",
    d: "M169.182,2.575V.337a.337.337,0,0,0-.675,0V2.575a.337.337,0,0,0,.675,0Z",
    transform: "translate(-155.855 0)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25667",
    "data-name": "Path 25667",
    d: "M51.631,51.245a.337.337,0,0,0,.237-.578l-1.6-1.568a.338.338,0,1,0-.473.482l1.6,1.567A.338.338,0,0,0,51.631,51.245Z",
    transform: "translate(-45.963 -45.324)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25668",
    "data-name": "Path 25668",
    d: "M2.928,176.254a.337.337,0,0,0-.337-.337H.337a.337.337,0,1,0,0,.675H2.59a.337.337,0,0,0,.337-.337Z",
    transform: "translate(0 -162.708)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25669",
    "data-name": "Path 25669",
    d: "M266.354,51.256a.337.337,0,0,0,.236-.1l1.6-1.567a.337.337,0,1,0-.472-.482l-1.6,1.567a.337.337,0,0,0,.236.578Z",
    transform: "translate(-246.042 -45.334)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25670",
    "data-name": "Path 25670",
    d: "M309.945,176.254a.337.337,0,0,0-.337-.337h-2.252a.337.337,0,0,0,0,.675h2.252A.337.337,0,0,0,309.945,176.254Z",
    transform: "translate(-283.966 -162.708)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyCallout);
export default __webpack_public_path__ + "static/media/emergency-callout.48c94f801ffcc5fc643fc6a1ae723db2.svg";
export { ForwardRef as ReactComponent };